import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhyBasetaoSection from './components/WhyBasetaoSection';
import ReviewSection from './components/ReviewSection';
import CtaBanner from './components/CtaBanner';
import FaqSection from './components/FaqSection';
import ArticlesSection from './components/ArticlesSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhatIsSection />
        <WhyBasetaoSection />
        <ArticlesSection />
        <ReviewSection />
        <CtaBanner />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}